import React from "react"
import { Link as GatsbyLink, graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import Img from "gatsby-image"
import bgCylinder from '../../images/rectangle-gradient.png'
import styles from "./signup.module.css"

const Signup = props => {
  const data = useStaticQuery(graphql`
    query {
      athleteImage: file(relativePath: { eq: "adobe-stock-v2.png" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      background: file(relativePath: { eq: "features-bg.png" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <div className={styles.Wrapper} id="features">
      <div className={styles.CopyWrapper}>
        <div className={styles.Copy}>
          <h2>Keep Flexing</h2>
          <h4>Create. Flex. Track. Share</h4>
          <p>
            Whether you’re just starting to get into shape, or ready for the
            next challenge, Flex gives you the ability to set your own pace,
            pick exercises that work for you, and continuously challenge
            yourself over time.
          </p>
          <p>
            Health is a journey, and Flex is dedicated to supporting your
            personal journey with help from a community of friends.
          </p>

          <button className={styles.Button} onClick={props.handleClick}>Sign Up</button>
        </div>
      </div>
      <div className={styles.ImgWrapper}>
        <div>
          <img src={bgCylinder} className={styles.bgCylinder1}/>
          <img src={bgCylinder} className={styles.bgCylinder2}/>
          <img src={bgCylinder} className={styles.bgCylinder3}/>
        </div>
        <Img
          fluid={data.athleteImage.childImageSharp.fluid}
          className={styles.Athlete}
          alt="Athlete running pose"
        />
      </div>
    </div>
  )
}

export default Signup
